import classNames from "classnames";
import { useEffect, useState } from "react";
import style from "./FavouriteButton.module.scss";
import { hasFavourite, saveFavourite } from "./favouritesService";

const FavouriteButton = ({ sectionTitle, sectionUrl, type, triggerToast, styling }) => {
  const [selected, setSelected] = useState(hasFavourite(sectionTitle, type));

  useEffect(() => {
    setSelected(hasFavourite(sectionTitle, type))
  }, [sectionTitle]);

  const setFavourite = () => {
    const added = saveFavourite(sectionTitle, sectionUrl, type);
    setSelected(!selected);
    triggerToast(added);
  };

  return (
    <button
      type="button"
      onClick={setFavourite}
      data-title={sectionTitle}
      data-url={sectionUrl}
      aria-label={`Favourite ${sectionTitle}`}
      className={classNames(style.button, styling)}
    >
      <i
        className={classNames("iconSize", {
          "tg-icons-Star": selected !== true,
          "tg-icons-StarFill": selected === true,
        })}
      ></i>
    </button>
  );
};

export default FavouriteButton;
